import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { AliOssClientService } from '../../services/ali-oss-client.service';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidatorError, ControlValidateMoment } from '../../types/validator.types';
import { ValueControlViewModel } from '../../types/control.types';

export class FileUpLoadOssViewModel extends ValueControlViewModel {
  /**
   * æ¯å¦éæ©å¤ä¸ª
   *
   */
  multiple: boolean;

  /**
   * æ»æ°ééå¶
   *
   */
  totalNumber: number;
  templateName: string;
  templateUrl: string;
  templateHidden: string;
}

@Component({
  selector: 'df-file-upload-oss',
  templateUrl: './file-upload-oss.component.html',
  styleUrls: ['./file-upload-oss.component.scss']
})
export class FileUploadOssComponent extends AbstractValueControlBase<FileUpLoadOssViewModel> implements OnInit {
  type = ControlTypeName.fileUpLoad;
  isDesign = false;
  @Input() fileSize?: number;
  @Input() fileNumber?: number = 10;
  @Input() region: string;
  @Input() accessKeyId: string;
  @Input() accesskey: string;
  @Input() bucket: string;
  @Input() accept?: string[] = [];
  @Input() buttonType?: string = 'rectangle';
  @Input() uploadButtonBg?: string = 'btn-success';
  @Input() uploadButton?: boolean = false;

  @Output() uploadStatus = new EventEmitter();

  @ViewChild(`input1`) input1: ElementRef;
  @ViewChild(`input2`) input2: ElementRef;

  client: any;
  filesList: any[] = [];
  randomId: number;
  isDisabledUploadButton: boolean = true;
  isFirefox: boolean = false;

  fileIndex: number = 0;
  constructor(protected element: ElementRef, private aliOssClient: AliOssClientService) {
    super();
    this.randomId = Math.random();
    this.isFirefox = /Firefox/.test(navigator.userAgent);
  }

  ngOnInit() {
    this.client = this.aliOssClient.getClient(this.model.id);
    if (!this.model.value) {
      this.model.value = [];
    }
    console.log(this.model, 'model');
    // éå¶æ°éï¼æ ¹æ®å¾éæ¯å¦å¤ä¸ª
    this.fileNumber = this.model.multiple ? this.model.totalNumber || this.fileNumber : 1;
    // this.validators = this.getValidators();
  }

  removeButtonState(file: any): boolean {
    if (!file) {
      return false;
    }
    return (file.percent === 0 || file.percent === 100) && file.remove && file.status !== 'error' && !this.readonly;
  }

  bindEvents(): void {
    this.valueElement = this.element.nativeElement;
    this.bindEventsToEl(this.valueElement);
  }

  // å½è®¾ç½®modelçvalueæ¶
  setModelValue(value: any) {
    if (!value) {
      value = '[]';
    }
    this.filesList = [];
    this.model.value = [];
    if (!value) {
      return;
    }

    if (value instanceof Array) {
      this.model.value = value;
    } else {
      this.model.value = JSON.parse(value);
    }

    // this.model.value = value;
    if (!(this.model.value instanceof Array)) {
      this.model.value = [];
    }
    this.filesList = [];
    this.filesList.push(...this.model.value);
    for (const files of this.filesList) {
      files[`index`] = this.fileIndex;
      this.fileIndex++;
    }
  }
  getModelValue() {
    return JSON.stringify(this.model.value);
  }

  // IsDisabledUploadButton
  isDisabled() {
    if (this.filesList.length === 0) {
      this.isDisabledUploadButton = true;
    } else {
      for (const file of this.filesList) {
        if (!file.isLoad) {
          this.isDisabledUploadButton = false;
          return;
        }
      }
      this.isDisabledUploadButton = true;
    }
  }

  // Filter file type
  filterFileType(files: any[]) {
    return new Promise((resolve) => {
      const filesFilter: any[] = [];
      if (this.accept.length === 0) {
        resolve(files);
      } else {
        for (const file of files) {
          const fileName = file.name as string;
          this.accept.forEach((item) => {
            const pattern = new RegExp(`${item}`);
            if (pattern.test(fileName.toLocaleLowerCase())) {
              filesFilter.push(file);
            }
          });
        }
        resolve(filesFilter);
      }
    });
  }

  // Filter file size
  filterFileSize(files: any[]) {
    const filesFilter: any[] = [];
    return new Promise((resolve) => {
      if (!this.fileSize) {
        resolve(files);
      } else {
        for (const file of files) {
          const fileSize = file.size / 1024;
          if (fileSize <= this.fileSize) {
            filesFilter.push(file);
          }
        }
        resolve(filesFilter);
      }
    });
  }

  // Filter file number
  filterFileNumber(files: any[]) {
    return new Promise((resolve) => {
      if (files.length + this.filesList.length > this.fileNumber) {
        return;
      } else {
        resolve(files);
      }
    });
  }

  // Handle files
  handleFiles(files: any[]) {
    return new Promise((resolve) => {
      this.filterFileType(files).then((file: any[]) => {
        this.filterFileNumber(file).then((fil: any[]) => {
          this.filterFileSize(fil).then((filesArr: any[]) => {
            for (const filesA of filesArr) {
              filesA['loading'] = false;
              filesA['remove'] = false;
              filesA['percent'] = 0;
              filesA['isLoad'] = false;
              filesA['status'] = 'ready';
              filesA[`index`] = this.fileIndex;
              filesA[`validatorError`] = new ControlValidatorError(true, '');
              this.fileIndex++;
            }
            resolve(filesArr);
          });
        });
      });
    });
  }

  // Select files
  selectFiles($event: any) {
    $event.preventDefault();
    this.handleFiles($event.target.files || $event.dataTransfer.files)
      .then((file: any[]) => {
        this.filesList.push(...file);
        this.validateAtMoment(ControlValidateMoment.Input);
      })
      .then(() => {
        this.isDisabled();
      })
      .then(() => {
        if (!this.uploadButton) {
          this.uploadFile();
        }
      });

    setTimeout(() => {
      this.input1.nativeElement.value = null;
      this.input2.nativeElement.value = null;
    }, 300);
  }

  // Dragover preventDefault
  dragover($event: any) {
    $event.preventDefault();
  }

  // Remove files
  removeFile(index: number) {
    this.filesList[index]['removeAnimation'] = 'fadeOutRight';
    const removeFileIndex = this.filesList[index][`index`];
    setTimeout(() => {
      this.filesList.splice(index, 1);
      this.filesList = this.filesList;
      this.model.value = this.model.value.filter((s: any) => s[`index`] !== removeFileIndex);
      this.isDisabled();
      this.modelValueChange();
    }, 300);
  }

  // Upload files
  uploadFile() {
    for (const file of this.filesList) {
      if (file.isLoad) continue;
      if (file.validatorError && !file.validatorError.success) continue;

      const index = file.name.lastIndexOf('.');
      const key = `${file.name.substring(0, index)}|${new Date().valueOf()}|${Math.random()}${file.name.substring(
        index
      )}`;
      file['status'] = 'loading';

      const progress = function (pro: any) {
        return function (done: any) {
          file['percent'] = Number((pro * 100).toFixed(2));
          done();
        };
      };
      file['isLoad'] = true;
      this.isDisabled();
      this.client
        .multipartUpload(key, file, {
          progress: progress
        })
        .then((res: any) => {
          const href = res.res.requestUrls[0];
          if (/\?uploadId/.test(href)) {
            file['href'] = href.substring(0, href.indexOf('?'));
          } else {
            file['href'] = href;
          }
          file['status'] = 'success';
          this.uploadStatus.emit(res);
          const flattenObj = this.flattenObject(file);
          this.model.value.push(flattenObj);

          this.modelValueChange();
        })
        .catch((reason: any) => {
          file['status'] = 'error';
          this.uploadStatus.emit(reason);
        });
    }
    this.input1.nativeElement.value = null;
    this.input2.nativeElement.value = null;
  }

  // ååä¸­çåæ°ä¹è½¬æ¢åºæ¥
  flattenObject(obj: any) {
    const result = {};
    // tslint:disable-next-line:forin
    for (const key in obj) {
      result[key] = obj[key];
    }
    return result;
  }

  private modelValueChange() {
    this.validateAtMoment(ControlValidateMoment.Input);
    this.broadControlValueChange();
  }
}
